var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHintI102102 = function SvgHintI102102(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 102,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hint_i_102_102_svg__a)",
    d: "M90 12H12v78h78z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3177FF",
    d: "M6 0h90v6H6zM6 96h90v6H6zM6 6v90H0V6zM102 6v90h-6V6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.473 78v-2.422H34V62.684h2.473V60.21h5.052V41.735h-5.052v-2.419H34V26.42h2.473V24h29.264v2.42h2.42v12.896h-2.42v2.42h-5.054V60.21h5.054v2.473h2.42v12.894h-2.42V78z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hint_i_102_102_svg__b)",
    d: "M62.419 63.525v2.473h2.422v6.265H62.42v2.422H39.788v-2.422h-2.473v-6.265h2.473v-2.473h5.054V38.421h-5.054v-2.423h-2.473v-6.261h2.473v-2.422h22.631v2.422h2.422v6.261H62.42v2.422h-5.051v25.105z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hint_i_102_102_svg__a",
    x1: 11.64,
    x2: 90.358,
    y1: 11.565,
    y2: 90.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3E2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hint_i_102_102_svg__b",
    x1: 36.18,
    x2: 65.973,
    y1: 26.256,
    y2: 75.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3177FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7474E6"
  })))));
};
export default SvgHintI102102;